import { useApi } from '@/composables/use-api.ts';
import dayjs from 'dayjs';

export interface AttendanceTimeline {
  type: string;
  action?: string;
  direction?: string;
  name: string;
  location?: string;
  recordDt: dayjs.Dayjs;
  activityId?: number;
}

function toActionName(action: string) {
  switch (action) {
    case 'WORK_START':
      return '근무 시작';
    case 'WORK_END':
      return '근무 종료';
    case 'AWAY_START':
      return '자리비움 시작';
    case 'AWAY_END':
      return '자리비움 종료';
    default:
      return 'Unknown';
  }
}

function toDirection(action: string) {
  switch (action) {
    case 'WORK_START':
      return 'IN';
    case 'WORK_END':
      return 'OUT';
    case 'AWAY_START':
      return 'OUT';
    case 'AWAY_END':
      return 'IN';
    default:
      return 'IN';
  }
}

function toTaggingName(action: string) {
  switch (action) {
    case 'IN':
      return '입구 태깅';
    case 'OUT':
      return '출구 태깅';
    default:
      return 'Unknown';
  }
}

export async function getTimelinesAsync(
  attendanceId: number,
  date: string,
  empNo?: number
) {
  const { attendance, secom } = useApi();

  const items: AttendanceTimeline[] = [];

  (await attendance.activity.listByAttendanceIdAsync(attendanceId)).forEach(
    (activity) => {
      items.push({
        type: 'activity',
        action: activity.action,
        direction: toDirection(activity.action),
        name: toActionName(activity.action),
        recordDt: dayjs(activity.recordDt),
        location: activity.location,
        activityId: activity.id
      });
    }
  );
  (await secom.listAsync(date, empNo)).forEach((tagging) => {
    items.push({
      type: 'tagging',
      direction: tagging.gateDirection,
      name: toTaggingName(tagging.gateDirection),
      recordDt: dayjs(tagging.recordDt),
    });
  });

  items.sort((a, b) => a.recordDt.valueOf() - b.recordDt.valueOf());
  return items;
}
